//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProduct'
import ProviderModel from '@/models/Purchase/PchProvider'

//
import ProductFilters from '@/views/Warehouse/WhProduct/partials/ProductFilters'
import ProductHeaders from '@/views/Warehouse/WhProduct/partials/ProductHeaders'
import PurchaseInvoiceDetailHeaders from '@/views/Purchase/PchPurchaseInvoice/partials/PurchaseInvoiceDetailHeaders'

//
import { RequiredRule, noEmpty } from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            label: 'Proveedor',
            itemText: 'business_name',
            itemValue: 'id',
            model: ProviderModel,
            noObject: true,
            readonly: true,
        },
        trigger(ctx) {
            //
            const provider = ctx.getInput('pch_provider_id')
            const providerSelected = provider.getSelected()
            const providerBranchOffices = ctx.getField(
                'pch_provider_branch_offices_id'
            )
            //
            providerBranchOffices.props.items = providerSelected.branch_offices
            //
            ctx.$refs.fieldset.$forceUpdate()
        },
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'autocomplete',
        props: {
            clearable: true,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales',
            rules: [RequiredRule],
        },
    },
    {
        name: 'invoice_number_id',
        type: 'select',
        props: {
            chips: true,
            //deletableChips: true,
            itemText: 'invoice_number',
            itemValue: 'id',
            label: 'N° de factura',
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        props: {
            label: 'Método de pago',
            itemText: 'type',
            itemValue: 'id',
            model: PaymentConditionModel,
            noObject: true,
            paramSearch: 'type',
        },
        trigger: ctx => {
            ctx.value.pch_payment_condition = ctx.getInput('pch_payment_condition_id').getSelected()
            ctx.value.resetPaymentDate()
        }
    },
    {
        name: 'authorization_date',
        type: 'date-field',
        props: {
            label: 'Fecha autorización',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'receiving_date',
        type: 'date-field',
        props: {
            label: 'Fecha recepción',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'emission_date',
        type: 'date-field',
        props: {
            label: 'Fecha emisión',
            rules: [RequiredRule],
        },
        trigger: ctx => ctx.value.resetPaymentDate(),
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Fecha pago',
            rules: [RequiredRule],
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            name: 'selected-table-field',
            checkable: true,
            headers: PurchaseInvoiceDetailHeaders,
            noDataText: 'Sin productos.',
            noExport: true,
            pickerProps: {
                filters: ProductFilters,
                headers: ProductHeaders,
                mapper: row => {
                    //
                    row.wh_product_id = row.id
                    row.quantity = 0
                    row.net_price = 0
                    row.global_discount_line_amount = 0
                    row.net_total = 0
                    //
                    return row
                },
                service: ProductModel,
                paramFilter:{type:'item'}
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos',
        },
        slots: {
            'items': 'table-items',
        },
    },
    {
        name: 'acc_cost_center_id',
        type: 'autocomplete-model',
        props: {
            label: 'Centro costo',
            itemText: 'name',
            itemValue: 'id',
            model: CostCenterModel,
            noDataText: 'No se encontraron centros de costo.',
            noAsyncSearch: true,
            noObject: true,
            paramSearch: 'name',
            rules: [RequiredRule],
        },
    },
    {
        name: 'is_exent',
        type: 'checkbox',
        props: {
            label: 'Factura exenta',
        },
    },
    {
        name: 'payable',
        type: 'checkbox',
        props: {
            falseValue: true,
            label: 'Bloquear pago',
            trueValue: false,
        },
    },
    {
        name: 'selected_net_subtotal',
        type: 'currency-field',
        props: {
            label: 'Neto',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'selected_global_discount_amount',
        type: 'float-field',
        props: {
            label: 'Descuento (%)',
            reverse: true,
        },
        flex: {
            'offset-xs6': true,
            sm3: true,
        },
    },
    {
        name: 'selected_new_net_subtotal',
        type: 'currency-field',
        props: {
            label: 'Subtotal',
            readonly: true,
            reverse: true,
        },
        flex: {
            sm3: true,
        },
    },
    {
        name: 'extra_total',
        type: 'currency-field',
        props: {
            label: 'Impuesto adicional',
            reverse: true,
        },
        flex: {
            'offset-xs3': true,
            sm3: true,
        },
    },
    {
        name: 'selected_iva',
        type: 'currency-field',
        props: {
            label: 'IVA',
            readonly: true,
            reverse: true,
        },
        flex: {
            sm3: true,
        },
    },
    {
        name: 'selected_total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
        flex: {
            sm3: true,
        },
    },
]
